import { CreateUpdateMooringComponent, MooringComponent } from './MooringComponent';

class BaseMooringAnchorLine {
  MoorlogNo!: string;
  AnalysisNo!: string;
  DimForce?: number;
  IsAccident!: boolean;

  MblRopes?: number;
  MblSinkRopes?: number;
  MblStraps?: number;

  MblChainShackleConnectionPlates?: number;

  MblAnchoring?: number;

  MblUsedChainRopeWithKnot?: number;

  BottomAnchoringUplift?: number;
  DepthAtAnchoringPoint?: number;

  BuoyId!: number;
  BuoyNo?: string;

  Slope?: number;

  StartPositionLat!: string;
  StartPositionLong!: string;

  StopPositionLat!: string;
  StopPositionLong!: string;

  HoldingPowerAnchoring?: number;
  LengthOfBottomRope!: number;
  LengthOfRope!: number;
  TotalLength!: number;
}

export class UpdateMooringAnchorLineDto extends BaseMooringAnchorLine {
  Id!: number;
  MoorlogNo!: string;
  Components!: CreateUpdateMooringComponent[];
}

export class MooringProductionAnchorLineSlotDto {
  ComponentId?: number;
  ArticleProductId?: number;
  ProductName!: string;
  Quantity?: number;
  ComponentCount!: number;
}

export class AddMooringAnchorLineDto {
  MoorlogNo!: string;
  AnalysisNo!: string;
  BuoyId!: number;
}

export class MooringAnchorLine extends BaseMooringAnchorLine {
  Id!: number;
  Components!: MooringComponent[];
  HasUnresolvedComments!: boolean;
  HasUnresolvedComponentComments!: boolean;
  HasComments!: boolean;
}

export class MooringProductionAnchorLineDto {
  Id!: number;
  MooringId!: number;
  MoorlogNo!: string;
  AnalysisNo!: string;
  DepthAtAnchoringPoint!: number | null;
  MblRopes!: number | null;
  MblSinkRopes!: number | null;
  MblStraps!: number | null;
  MblChainShackleConnectionPlates!: number | null;
  MblAnchoring!: number | null;
  HoldingPowerAnchoring!: number | null;
  BottomAnchoringUplift!: number | null;
  AnchorType!: string;
  AnchoringUtilizationFactor!: number | null;
  ShackleForAnchoring!: string;
  BottomChainDimension!: string;
  BottomChainUtilizationFactor!: number | null;
  LengthOfBottomRope!: number;
  ShackleForSpliceBottomChain!: string;
  TonsForCounterWeightUpLift!: number | null;
  ShacklesForCounterWeight!: number;
  TrianglePlateForCounterWeight!: number;
  MeterChainFromAnchoringToCounterWeight!: number | null;
  MeterChainForRope!: number | null;
  ThrawlBalls!: number | null;
  ShackleForRope!: string;
  Thimble!: string;
  LengthOfRope!: number;
  RopeDimension!: string;
  RopeType!: string;
  RopeMbl!: number;
  RopeUtilizationFactor!: number | null;
  AnchorLineStrap!: string;
  AnchorLineStrapUtilizationFactor!: number | null;
  LengthAnchorLineStrap!: string;
  DimForce!: number | null;
  AnchorSlot!: MooringProductionAnchorLineSlotDto;
  AnchoringShackleSlot!: MooringProductionAnchorLineSlotDto;
  BottomChainSlot!: MooringProductionAnchorLineSlotDto;
  SpliceBottomChainShackleSlot!: MooringProductionAnchorLineSlotDto;
  RopeShackleSlot!: MooringProductionAnchorLineSlotDto;
  ThimbleSlot!: MooringProductionAnchorLineSlotDto;
  RopeSlot!: MooringProductionAnchorLineSlotDto;
  AnchorLineStrapSlot!: MooringProductionAnchorLineSlotDto;
}

export class UpdateMooringProductionAnchorLineDto extends MooringProductionAnchorLineDto {}
